import React from 'react'
import styled from 'styled-components'

type Props = {
  title: string
  icon: string
  firstYear: string
  firstValue: string
  secondYear: string
  secondValue: string
  description: string
  url: string
}

export const HomeIndicatorCard: React.FC<Props> = ({ title, icon, firstYear, firstValue, secondYear, secondValue, description, url }) => {
  return (
    <IndicatorCard icon={icon}>
      <a className="indicator" href={url}>
        <div className="indicator-picture"></div>
        <div className="indicator-content">
          <h3>{title}</h3>
          <div className="indicator-content__data">
            <div><small>último dato</small><br/>{firstYear}</div>
            <div><small>objetivo</small><br/>{secondYear}</div>
            <div>{firstValue}</div>
            <div>{secondValue}</div>
          </div>
          <div className="indicator-description">{description}</div>
        </div>
      </a>
    </IndicatorCard>
  )
}

type IndicatorCardProps = {
  icon: string
}

const IndicatorCard = styled.div<IndicatorCardProps>`
  
  .indicator {
    display: grid;
    grid-template-columns: 100px auto auto;
    color: #000;
    transition: all linear .2s;

    &:hover {
      color: #30cdde;
    }

    &-picture {
      position: relative;
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      border-radius: 50%;
      width: 80px;
      height: 80px;
      margin-top: 10px;
      background: #30cdde url('${props => props.icon}') 50% 50% no-repeat;
      background-size: 44px;

      svg {
        position: relative;
        right: 12px;
        bottom: 12px;
      }
    }

    &-content {
      grid-column: 2 / 4;
      grid-row: 1 / 2;

      h3 {
        margin: 0;
        font-size: 16px;
      }

      &__data {
        display: grid;
        grid-template-columns: repeat(2, 120px);
        grid-template-rows: repeat(2, 1fr);
        font-weight: bold;
      }
    }

    &-description {
      grid-column: 1 / 4;
      grid-row: 2 / 3;
      font-size: small;
    }
    
  }
`
